import { Component, computed, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/global';
import { Services } from "src/app/services/api.service"
import { environment } from 'src/environments/environment';
import { FILTER_STRINGS, DAYS_OF_WEEK, ELEMENT_CLASS, ACTION_ID } from 'src/app/common/constants';
import { ActionItem, EventItem, SelectedDropdownValue } from 'src/app/common/interfaces';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionComponent } from '../accordion/accordion.component';
import { AccordionItemComponent } from '../accordion/accordion-item.component';
import { ModalNames } from 'src/app/common/modal.config';
import { ModalService } from 'src/app/services/modal.service';
import { SocialsComponent } from '../promo/socials/socials.component';
import { SeasonTicketComponent } from 'src/app/pages/season-ticket/season-ticket.component';

@Component({
  selector: 'app-events-list',
  templateUrl:  `./${environment.pageFolder}/events-list.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/events-list.${environment.pageFolder}.component.sass`],
  providers: [ Services ],
  standalone: true,
  imports: [CommonModule, TranslateModule, AccordionComponent, AccordionItemComponent, SocialsComponent, SeasonTicketComponent]
})

export class EventsListComponent implements OnInit {
  allEventsCopy: EventItem[] = [];
  allCompetitions: string[] = [];
  allTeams: string[] = [];
  selectedStartDate: Date | null = null;
  selectedEndDate: Date | null = null;
  filterValueTeam: string = FILTER_STRINGS.ALL;
  filterValueCompetition: string = FILTER_STRINGS.ALL;
  public startDateFilter = FILTER_STRINGS.START_DATE;
  public endDateFilter = FILTER_STRINGS.END_DATE;
  allEventsAreInactive: boolean = false;
  normalAction = ACTION_ID.NORMAL.toString();
  subscriberAction = ACTION_ID.SUBSCRIBER_TICKET.toString();
  page = environment.page;
  @Input() allEvents!: EventItem[];
  @Input() isUserProfilePage: boolean = false;
  @Input() currentOrderEventId: any | null = null;
  allEventsList: EventItem[] = [];
  seasonExclusiveAction = ACTION_ID.EXCLUSIVE_SUBSCRIBER_TICKET.toString();
  selectedEvent: EventItem | null = null;
  @Output() selectedEventEmit = new EventEmitter<EventItem>();
  public readonly modalNamesEnum = ModalNames;
  readonly isEventModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.EventModal) ?? false);

  constructor(
    public Services: Services,
    private Router: Router,
    public modalService: ModalService
  ) {}

  ngOnInit(): void {
    let days = GlobalConstants.language === "hr" ? DAYS_OF_WEEK.HR : DAYS_OF_WEEK.EN;
    let isHeroEventSelected = false;

    this.allEvents.map((item: EventItem) => {
      let startTime = new Date(item.startTime);
      let month = (startTime.getMonth()+1).toString();
      let date = startTime.getDate().toString();
      item.class = "";

      (date.length === 1) && (date = "0" + date);
      (month.length === 1) && (month = "0" + month);

      let dateAndMonth = date + "." + month;
      let dayInWeek = days[startTime.getDay()];
      let hours = startTime.getHours()
      let minutes = startTime.getMinutes().toString()

      if(minutes.length === 1) {
        minutes = "0" + minutes;
      }

      item.dayInWeek = dayInWeek;
      item.date = dateAndMonth;
      item.time = hours + ":" + minutes;

      if(!isHeroEventSelected && item.isVisible === true && (item.team1Name || item.isGroup) && !this.isUserProfilePage) {
        item.isShownOnHero = true;
        isHeroEventSelected = true;
      } else {
        item.isShownOnHero = false;
        this.allEventsList.push(item);
      }
    })

    this.allEventsCopy = this.allEvents;
    this.uniqueCompetitions();
    this.uniqueArrayTeams();
    const loader = document.getElementById("loader-container");
    loader!.style.display = "none";
  }

  filterByTeams(filterValue: Event | SelectedDropdownValue) {
    if ('target' in filterValue) {
      const target = filterValue.target as HTMLSelectElement;
      this.filterValueTeam = target.value;
    } else {
      this.filterValueTeam = filterValue.value;
    }

    const filterTeamName = this.filterValueTeam ? this.filterValueTeam.trim().toLowerCase() : FILTER_STRINGS.ALL;

    this.allEvents = this.allEventsCopy.filter((item: EventItem) => {
      if (item.isVisible !== true) {
        item.class = ELEMENT_CLASS.INACTIVE;
        return false;
      }

      const isCompetitionMatch = this.filterValueCompetition === FILTER_STRINGS.ALL || item.eventGroupName === this.filterValueCompetition;
      const isDateMatch = this.checkFilterDateInputMatch(item.startTime);

      if ((filterTeamName === FILTER_STRINGS.ALL && isCompetitionMatch && isDateMatch) ||
        ((filterTeamName === item.team1Name.trim().toLowerCase() || filterTeamName === item.team2Name.trim().toLowerCase()) && isCompetitionMatch && isDateMatch)) {
          item.class = ELEMENT_CLASS.ACTIVE;
      } else {
        item.class = ELEMENT_CLASS.INACTIVE;
      }

      return item;
    });

    this.updateAllEventsAreInactive();
  }

  filterByCompetition(filterValue: Event | SelectedDropdownValue) {
    if ('target' in filterValue) {
      const target = filterValue.target as HTMLSelectElement;
      this.filterValueCompetition = target.value;
    } else {
      this.filterValueCompetition = filterValue.value;
    }

    this.allEvents = this.allEventsCopy.filter((item: EventItem) => {
      const isDateMatch = this.checkFilterDateInputMatch(item.startTime);

      if(item.eventGroupName === this.filterValueCompetition && isDateMatch && (item.team2Name === this.filterValueTeam || item.team1Name === this.filterValueTeam || this.filterValueTeam === FILTER_STRINGS.ALL)) item.class = ELEMENT_CLASS.ACTIVE
      else item.class = ELEMENT_CLASS.INACTIVE
      if(this.filterValueCompetition === FILTER_STRINGS.ALL && (item.team2Name === this.filterValueTeam || item.team1Name === this.filterValueTeam) && isDateMatch) item.class = ELEMENT_CLASS.ACTIVE
      if(this.filterValueCompetition === FILTER_STRINGS.ALL && this.filterValueTeam === FILTER_STRINGS.ALL && isDateMatch) item.class = ELEMENT_CLASS.ACTIVE
      return item
    })

    this.updateAllEventsAreInactive();
  }

  filterByDate(selectedDate: Event, filterString:string) {
    const inputElement = selectedDate.target as HTMLInputElement;
    const selectedDateValue = inputElement.value;

    if (selectedDateValue !== "") {
      if (filterString === this.startDateFilter) {
        this.selectedStartDate = new Date(selectedDateValue);
        this.selectedStartDate.setHours(0, 0, 0, 0);
      } else {
        this.selectedEndDate = new Date(selectedDateValue);
        this.selectedEndDate.setHours(23, 59, 59, 999);
      }

      this.mimicDropdownSelect();
    } else {
      if (filterString === this.startDateFilter) {
        this.selectedStartDate = null;
      } else {
        this.selectedEndDate = null;
      }

      this.mimicDropdownSelect();
    }
  }

  mimicDropdownSelect () {
    const mimicTeamSelect: SelectedDropdownValue = {
      value: this.filterValueTeam
    }
    this.filterByTeams(mimicTeamSelect);

    const mimicCompetitionSelect: SelectedDropdownValue = {
      value: this.filterValueCompetition
    }
    this.filterByCompetition(mimicCompetitionSelect);

    this.updateAllEventsAreInactive();
  }

  onShowCalendar(event: Event) {
    const dateInput = event.target as HTMLInputElement;
    dateInput.min = new Date().toISOString().split("T")[0];
    dateInput.showPicker();
  }

  uniqueCompetitions() {
    const competitions = this.allEvents
      .filter((item: EventItem) => item.isVisible)
      .map((item: EventItem) => item.eventGroupName)
      .filter((groupName: string) => groupName && groupName.length > 0);

    this.allCompetitions = [...new Set(competitions)];
  }

  uniqueArrayTeams() {
    const opponentTeams: string[] = [];
    this.allEvents
      .filter((item: EventItem) => item.isVisible === true)
      .map((item: EventItem) => {
        item.team1Name && opponentTeams.push(item.team1Name);
        item.team2Name && opponentTeams.push(item.team2Name);
      });
    this.allTeams = [...new Set(opponentTeams)];
  }

  goToEventPage(connId: string, event: EventItem, isGroup: boolean) {
    this.selectedEvent = event;
    let seasonTicketMembersExclusive = event.actions.some((item: ActionItem) => {
      return Number(item.id) === ACTION_ID.EXCLUSIVE_SUBSCRIBER_TICKET;
    });

    if(isGroup && seasonTicketMembersExclusive) {
      this.selectedEventEmit.emit(event);

      if(GlobalConstants.isAuth) {
        this.modalService.openModal(ModalNames.EventModal);
      } else {

        sessionStorage.setItem('openModal', `EventModal`);
        localStorage.setItem('selectedEvent', JSON.stringify(event));
        this.modalService.openModal(ModalNames.Login);
      }
    } else if(isGroup && !seasonTicketMembersExclusive) {
      this.Router.navigate([`event/${connId}/${event.eventId}/${event.actions[0].id}/${event.hashedId}`]);
    } else {
      this.Router.navigate([`event/${connId}/${event.eventId}/${ACTION_ID.NORMAL}/${event.hashedId}`]);
    }
  }

  checkFilterDateInputMatch(eventStartTime: string): boolean {
    const eventDate = new Date(eventStartTime);
    let isDateMatch = true;

    if (this.selectedStartDate) {
      isDateMatch = isDateMatch && eventDate >= this.selectedStartDate;
    }
    if (this.selectedEndDate) {
      isDateMatch = isDateMatch && eventDate <= this.selectedEndDate;
    }

    return isDateMatch;
  }

  updateAllEventsAreInactive() {
    this.allEventsAreInactive = this.allEvents.length === 0 ||
      this.allEvents.every((item: EventItem) => item.class === ELEMENT_CLASS.INACTIVE);
  }
}
